/** 화면 중앙 상단에 짧게 뜨는 안내 메시지. */

import Phaser from 'phaser';
import type { ToastPayload } from '../game/events';
import { TEXT_COLOR, UI_FONT } from './theme';

const COLORS: Record<NonNullable<ToastPayload['tone']>, string> = {
  info: TEXT_COLOR.bright,
  warn: TEXT_COLOR.warn,
  good: TEXT_COLOR.good,
};

export class Toast {
  private readonly active: Phaser.GameObjects.Text[] = [];

  constructor(private readonly scene: Phaser.Scene) {}

  show(payload: ToastPayload): void {
    const text = this.scene.add.text(this.scene.scale.width / 2, 96, payload.message, {
      fontFamily: UI_FONT,
      fontSize: '16px',
      color: COLORS[payload.tone ?? 'info'],
      stroke: '#14141c',
      strokeThickness: 5,
      align: 'center',
      wordWrap: { width: Math.min(720, this.scene.scale.width - 48), useAdvancedWrap: true },
    });
    text.setOrigin(0.5, 0.5);

    this.active.push(text);
    this.reflow();

    this.scene.tweens.add({
      targets: text,
      y: text.y - 26,
      alpha: 0,
      delay: 900,
      duration: 420,
      onComplete: () => {
        const index = this.active.indexOf(text);
        if (index >= 0) this.active.splice(index, 1);
        text.destroy();
        this.reflow();
      },
    });
  }

  private reflow(): void {
    this.active.forEach((text, i) => {
      if (text.alpha < 1) return;
      text.y = 96 + i * 26;
    });
  }
}
